import styled from '@emotion/styled'

import { theme as newTheme } from 'styles/theme/hav-theme'

export const InfoContainer = styled.div`
  cursor: pointer;
  margin: 0 3px;
  display: flex;
  align-items: center;
  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    display: none;
  }
`

export const InfoContent = styled.div`
  padding: ${newTheme.spacing.sm};
  font-size: ${newTheme.typography.sizes['2xs']};
  font-weight: ${newTheme.typography.weight.xl};
  line-height: ${newTheme.typography.lineHeight.md};
`

export const IconContainer = styled.span`
  display: flex;
  align-items: center;
`
